var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationMark = function SvgExclamationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#exclamation-mark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.312 27-2.5 3.227 1.586 3.762-3.253 2.468.553 4.045-3.782 1.539-.512 4.05-4.05.512-1.54 3.783-4.045-.553-2.468 3.253-3.762-1.587-3.227 2.5-3.227-2.5-3.762 1.587-2.468-3.253-4.045.553-1.539-3.783-4.05-.511-.512-4.051-3.783-1.539.553-4.045-3.253-2.468 1.588-3.762L.312 27l2.502-3.227-1.588-3.762 3.253-2.468-.553-4.046L7.71 11.96l.512-4.051 4.05-.512 1.54-3.782 4.044.552L20.323.914 24.085 2.5 27.312 0l3.227 2.501L34.301.914l2.469 3.252 4.045-.552 1.538 3.782 4.051.512.512 4.051 3.782 1.539-.553 4.045 3.253 2.468-1.587 3.762 2.5 3.227Z",
    fill: "#E2BF83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.558 36.304a2.848 2.848 0 1 1 0 5.696 2.848 2.848 0 0 1 0-5.696Zm2.128-4.267c-.096 2.4-4.163 2.404-4.256-.001-.41-4.114-1.463-13.882-1.43-17.747.035-1.192 1.022-1.897 2.285-2.166A6.02 6.02 0 0 1 26.534 12c.434 0 .863.043 1.253.127 1.305.278 2.33 1.012 2.329 2.225l-.005.121-1.425 17.564Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "exclamation-mark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h54v54H0z"
  })))));
};
export default SvgExclamationMark;